<template>
    <div itemscope itemtype="http://schema.org/Thing" class="text-center">
        <div :id="'carousel'+_uid" class="carousel slide bx-narrative" data-interval="false" data-bx-narrative-name="gallery" data-bx-narrative-group-by="src">
            <ol class="carousel-indicators" v-if="showDots && showGallery()">
                <li v-for="(image, index) in singleImages" :data-target="'#carousel'+_uid" :data-slide-to="index" :class="{ active: index === 0 }"></li>
            </ol>
            <div class="carousel-inner text-center">
                <div v-for="(image, index) in singleImages" class="carousel-item prop-1-1" :class="{ active: index === 0 }">
                    <img class="position-absolute w-100 h-100 bx-narrative-item bx-narrative-button"
                         :src="image.urlMiddle"
                         :srcset="image.urlPreview+' 150w, '+image.urlSecondPreview+' 300w, '+image.urlMiddle+' 450w, '+image.url+' 660w'"
                         :alt="getAltText(image)"
                         :data-bx-item-id="image.urlMiddle"
                         width="660" height="660" v-if="index === 0">
                    <img class="position-absolute w-100 h-100 defer-load bx-narrative-item bx-narrative-button"
                         :data-src="image.urlMiddle"
                         :data-srcset="image.urlPreview+' 150w, '+image.urlSecondPreview+' 300w, '+image.urlMiddle+' 450w, '+image.url+' 660w'"
                         :alt="getAltText(image)"
                         :data-bx-item-id="image.urlMiddle"
                         width="660" height="660" v-else>


                  <img  class="bx-narrative-item bx-narrative-button absolute inset-0 object-contain object-center w-full m-auto max-h-75 cursor-pointer"
                         data-bx-item-id="https://www.nahrin.ch/media/catalog/product/cache/259ac1dc7414bbbc9b7f3d196edd39fc/v/i/virgin_mojito_drink_packshot_600x600.jpg" >


                </div>
            </div>
            <a class="carousel-control-prev" :href="'#carousel'+_uid" role="button" data-slide="prev" v-if="showGallery()">
                <span class="carousel-control-prev-icon bx-narrative-item bx-narrative-button" aria-hidden="true" data-bx-item-id="arrow|direction=left"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" :href="'#carousel'+_uid" role="button" data-slide="next" v-if="showGallery()">
                <span class="carousel-control-next-icon bx-narrative-item bx-narrative-button" aria-hidden="true" data-bx-item-id="arrow|direction=right"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>

        <div v-if="showThumbs && showGallery()" class="row align-content-center carousel-thumbnails mx-n2">
            <a v-for="(imagePreview, index) in carouselImages" class="col-2 px-2 pt-2 bx-narrative-item bx-narrative-button" :href="'#carousel'+_uid" :data-target="'#carousel'+_uid" :data-slide-to="index" :title="getImageName(imagePreview)" :data-bx-item-id="'thumb|selected=' + imagePreview.url">
                <div class="prop-1-1">
                    <img class="position-absolute w-100 h-100 defer-load border bg-white rounded"
                         :data-src="imagePreview.url"
                         :alt="getAltText(imagePreview)"
                         width="85" height="85">
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import { isNullOrUndefined } from "../../helper/utils";

export default {
    name: "item-image-carousel",

    props: {
        maxQuantity:
            {
                type: Number,
                default: 10
            },
        showThumbs:
            {
                type: Boolean,
                default: true
            },
        showDots:
            {
                type: Boolean,
                default: true
            },
        animationStyle:
            {
                type: String,
                default: "standard"
            }
    },

    inject: {
        itemId: {
            default: null
        }
    },

    data()
    {
        return {
            imageObserver: null
        }
    },

    computed:
        {
            currentVariation()
            {
                return this.$store.getters[`${this.itemId}/currentItemVariation`]
            },

            carouselImages()
            {
                return this.$options.filters.itemImages(
                    this.currentVariation.images,
                    "urlPreview"
                ).slice(0, this.maxQuantity);
            },

            singleImages()
            {
                const imagesAccessor = (this.currentVariation.images.variation && this.currentVariation.images.variation.length) ? 'variation' : 'all';
                return this.currentVariation.images[imagesAccessor].slice(0, this.maxQuantity);
            }
        },

    watch: {
        currentVariation:
            {
                handler(val, oldVal)
                {
                    if (val !== oldVal)
                    {
                        this.$nextTick(() => {
                            this.registerElementsForIntersection();
                        });
                    }
                },
                deep: true
            }
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.initCarousel();
        });
    },

    methods:
        {
            showImages(parentElement)
            {
                const list = parentElement.getElementsByClassName('defer-load');
                for (let elem of list) {
                    const dataSrcSet = elem.getAttribute("data-srcset");
                    const dataSrc = elem.getAttribute("data-src");

                    if (dataSrcSet && dataSrcSet !== elem.srcset) {
                        elem.srcset = dataSrcSet;
                    }
                    if (dataSrc && dataSrc !== elem.src) {
                        elem.src = dataSrc;
                    }
                }
            },

            registerElementsForIntersection()
            {
                if (this.showGallery()) {
                    this.observeElementsByClass('carousel-item active')
                    this.observeElementsByClass('carousel-thumbnails')

                    $(this.$el).on('slide.bs.carousel', () => {
                        this.showImages(this.$el);
                    });
                }
            },

            initCarousel()
            {
                if ("IntersectionObserver" in window) {
                    this.imageObserver = new IntersectionObserver((entries, imageObserver) => {
                        entries.forEach((entry) => {
                            if(entry.isIntersecting)
                            {
                                this.showImages(entry.target);
                                imageObserver.unobserve(entry.target);
                            }
                        });
                    });
                    this.registerElementsForIntersection();
                }
                else {
                    if (this.showGallery()) {
                        console.log("Your Browser is too old!");
                        const images = this.$el.getElementsByClassName('defer-load');
                        let i;
                        for (i = 0; i < x.length; i++) {
                            images[i].src = images[i].getAttribute("data-src");
                            images[i].removeAttribute("data-src");
                        }
                    }
                }
                $('#carousel'+this._uid).carousel();
            },

            getImageCount()
            {
                return this.carouselImages.length > this.maxQuantity ? this.maxQuantity : this.carouselImages.length;
            },

            getAltText(image)
            {
                let altText = image && image.alternate ? image.alternate : this.$options.filters.itemName(this.currentVariation);
                if (this.currentVariation.attributes.length > 0) {
                    altText = altText + ' ' + this.currentVariation.attributes[0].value.names.name
                }
                return altText;
            },

            getImageName(image)
            {
                let imageName =  image && image.name ? image.name : this.$options.filters.itemName(this.currentVariation);
                if (this.currentVariation.attributes.length > 0) {
                    imageName = imageName + ' ' + this.currentVariation.attributes[0].value.names.name
                }
                return imageName;
            },

            showGallery()
            {
                return (this.getImageCount() > 1);
            },

            observeElementsByClass(classList)
            {
                const list = this.$el.getElementsByClassName(classList);

                for (let elem of list) {
                    this.imageObserver.observe(elem);
                }
            }
        }
}
</script>
